module.exports = __webpack_public_path__ + "img/people-fill.1d9e9c35.svg";